export class EmailRegistrationParams {
  firstName: string;
  lastName?: string;
  email: string;
  status?: string;

  constructor(json: {firstName: string; lastName?: string; email: string; status?: string}) {
    this.firstName = json.firstName;
    this.lastName = json.lastName;
    this.email = json.email;
    this.status = json.status;
  }
}
